import { Directive, Inject, InjectionToken, Input, AfterViewInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { ExternalValidationsService } from './ExternalValidationsService';
import { ICardComponent } from '../../workflows/ICardComponent';
import { isNullOrUndefined } from '../objectUtils';

export const ICardComponentInjectionToken = new InjectionToken('CardComponent');

@Directive({
    selector: '[externalValidation]',
    standalone: false
})
export class ExternalValidationDirective implements AfterViewInit {
  
  @Input('externalValidation') mainFieldName: string = null;
  @Input() tableIndex: number;

  constructor(private ngModel: NgModel, private externalValidationsService: ExternalValidationsService, @Inject(ICardComponentInjectionToken) private parentCard : ICardComponent) {
    externalValidationsService.errorsChangedSubject.subscribe(x => this.checkErrors());
  }

  private setBaseErrors() {
    this.parentCard.cardExternalValidationErrors?.forEach(error => {
      if (error.fieldName == this.ngModel.name)
        this.ngModel.control.setErrors({ 'externalValidation': error.message });
    })
  }

  private setTableEditErrors() {
    this.parentCard.cardExternalValidationErrors?.forEach(error => {
      if ((error.tableLineNumber -1 )== this.tableIndex && error.tableFieldName == this.ngModel.name) {
        this.ngModel.control.setErrors({ 'externalValidation': error.message });
        this.ngModel.control.markAsTouched();
      }
    })
  }

  ngAfterViewInit(): void {
    //Como os campos os componentes de tableEdit podem estar fechados na altura da receção de novos erros
    //e ser abertos/renderizados à posteriori é necessario realizar esta validação no afterviewInit
    //adicionalmente o método necessita de estar dentro de um setTimeout para evitar erros de "ExpressionChangedAfterChecked"
    if (this.mainFieldName != "" || !isNullOrUndefined(this.mainFieldName))
      setTimeout(() => { this.checkErrors(); },0);
  }

  private checkErrors() {
    if (this.mainFieldName === "" || isNullOrUndefined(this.mainFieldName))
      this.setBaseErrors()
    else
      this.setTableEditErrors();
  }
}
